function CurrencyPipe(value: number, prefix = 'R$'): string {
  return prefix + value.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

export default CurrencyPipe
